/** Earliest selectable date of birth. */
export const MIN_BIRTH_DATE = new Date('1900-01-01');

/** Month the date-of-birth picker opens on when no date is set. */
export const DEFAULT_BIRTH_MONTH = new Date(1990, 0);

const ADULT_AGE_YEARS = 18;

/**
 * Latest date of birth of an adult: exactly `ADULT_AGE_YEARS` before `now`.
 * Used both to bound the picker's `endMonth` and to disable later days, so a
 * minor can never be selected whichever bound the picker applies.
 *
 * @param now - the reference instant
 * @returns the latest acceptable date of birth
 */
export function latestAdultBirthDate(now: Date): Date {
  return new Date(
    now.getFullYear() - ADULT_AGE_YEARS,
    now.getMonth(),
    now.getDate(),
  );
}

/**
 * Whether a calendar day is NOT an acceptable date of birth (before 1900 or
 * less than `ADULT_AGE_YEARS` before `now`).
 *
 * @param params.date - the day the picker offers
 * @param params.now - the reference instant
 * @returns `true` when the day must be disabled
 */
export function isDisabledBirthDate({
  date,
  now,
}: {
  date: Date;
  now: Date;
}): boolean {
  return date > latestAdultBirthDate(now) || date < MIN_BIRTH_DATE;
}
